import { ROLE_LABELS, type UserRole } from '@fenix/shared';
import { StatusBadge } from './StatusBadge';

const VARIANT: Record<UserRole, string> = {
  super_admin: 'bg-primary text-primary-foreground',
  admin: 'bg-primary/15 text-primary',
  operator: 'bg-info/15 text-info',
  viewer: 'bg-muted text-muted-foreground',
};

export function RoleBadge({ role }: { role: UserRole }) {
  return <StatusBadge label={ROLE_LABELS[role]} className={VARIANT[role]} />;
}
